export default "__VITE_ASSET__BBshF0v5__"